import Vue from 'vue';

export default function() {
	Vue.$ofsCrud.addResource({
		name: 'categories',
		transport: 'davinci',
		options: {
			namespaced: true
		}
	});
}
